export default __webpack_public_path__ + "assets/30deb616141078b12d5da2107184202c.eot";